import React, { useState, useEffect } from 'react';
import { Clock, Save } from 'lucide-react';
import api from '../services/api';
import '../styles/AdminComponents.css';
import '../styles/BusinessHours.css';

const DAYS = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

// Aceita 'HH:MM:SS', 'HH:MM' ou null e devolve 'HH:MM' (ou '' se não tiver)
const toHHMM = (t) => (t ? String(t).substring(0, 5) : '');

function BusinessHours() {
  const [hours, setHours] = useState(
    DAYS.map((_, i) => ({
      day_of_week: i,
      is_open: i >= 1 && i <= 5,
      open_time: '09:00',
      close_time: '18:00',
      break_start: '',
      break_end: ''
    }))
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/chatbot/hours');
        if (res.data?.length) {
          const map = {};
          res.data.forEach(h => { map[h.day_of_week] = h; });
          setHours(DAYS.map((_, i) => {
            const h = map[i];
            if (!h) return hours[i];
            return {
              ...h,
              open_time: toHHMM(h.open_time) || '09:00',
              close_time: toHHMM(h.close_time) || '18:00',
              break_start: toHHMM(h.break_start),
              break_end: toHHMM(h.break_end)
            };
          }));
        }
      } catch (e) { console.error(e); }
    })();
    // eslint-disable-next-line
  }, []);

  const update = (i, k, v) => {
    const next = [...hours]; next[i] = { ...next[i], [k]: v }; setHours(next);
  };

  const save = async () => {
    try {
      // Normaliza para 'HH:MM:SS' antes de salvar; intervalo vazio vira null
      const payload = hours.map(h => ({
        day_of_week: h.day_of_week,
        is_open: h.is_open,
        open_time: h.open_time?.length === 5 ? h.open_time + ':00' : h.open_time,
        close_time: h.close_time?.length === 5 ? h.close_time + ':00' : h.close_time,
        break_start: h.break_start ? (h.break_start.length === 5 ? h.break_start + ':00' : h.break_start) : null,
        break_end: h.break_end ? (h.break_end.length === 5 ? h.break_end + ':00' : h.break_end) : null
      }));
      await api.post('/chatbot/hours', { hours: payload });
      alert('Salvo');
    } catch (e) { alert('Erro'); }
  };

  return (
    <div className="admin-page">
      <h2><Clock size={20}/> Horário de Funcionamento</h2>
      <p className="muted">Fora deste horário, o chatbot envia a mensagem de ausência. Durante o intervalo, envia a mensagem de intervalo (configurável em "Chatbot & Menu").</p>

      {/* Desktop: tabela */}
      <div className="bh-table-wrap">
        <table className="admin-table">
          <thead><tr>
            <th>Dia</th><th>Aberto?</th><th>Abre às</th><th>Fecha às</th>
            <th>Intervalo início</th><th>Intervalo fim</th>
          </tr></thead>
          <tbody>
            {hours.map((h, i) => (
              <tr key={i}>
                <td>{DAYS[i]}</td>
                <td><input type="checkbox" checked={!!h.is_open} onChange={e => update(i, 'is_open', e.target.checked)}/></td>
                <td><input type="time" value={h.open_time || ''} onChange={e => update(i, 'open_time', e.target.value)}/></td>
                <td><input type="time" value={h.close_time || ''} onChange={e => update(i, 'close_time', e.target.value)}/></td>
                <td><input type="time" value={h.break_start || ''} onChange={e => update(i, 'break_start', e.target.value)}/></td>
                <td><input type="time" value={h.break_end || ''} onChange={e => update(i, 'break_end', e.target.value)}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: cards por dia */}
      <div className="bh-cards">
        {hours.map((h, i) => (
          <div key={i} className={`bh-day-card${h.is_open ? '' : ' bh-closed'}`}>
            <div className="bh-day-header">
              <span className="bh-day-name">{DAYS[i]}</span>
              <label className="bh-toggle">
                <input type="checkbox" checked={!!h.is_open} onChange={e => update(i, 'is_open', e.target.checked)}/>
                <span>{h.is_open ? 'Aberto' : 'Fechado'}</span>
              </label>
            </div>
            {h.is_open && (
              <>
                <div className="bh-times">
                  <div className="bh-time-field">
                    <label>Abre às</label>
                    <input type="time" value={h.open_time || ''}
                      onChange={e => update(i, 'open_time', e.target.value)}/>
                  </div>
                  <div className="bh-time-field">
                    <label>Fecha às</label>
                    <input type="time" value={h.close_time || ''}
                      onChange={e => update(i, 'close_time', e.target.value)}/>
                  </div>
                </div>
                <div className="bh-times">
                  <div className="bh-time-field">
                    <label>Intervalo início</label>
                    <input type="time" value={h.break_start || ''}
                      onChange={e => update(i, 'break_start', e.target.value)}/>
                  </div>
                  <div className="bh-time-field">
                    <label>Intervalo fim</label>
                    <input type="time" value={h.break_end || ''}
                      onChange={e => update(i, 'break_end', e.target.value)}/>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <button onClick={save} className="primary bh-save"><Save size={14}/> Salvar horários</button>
    </div>
  );
}

export default BusinessHours;
